<template>
  <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div
        v-if="readonly"
        style="
          text-align: center;
          font-weight: 800;
          width: 100%;
          background-color: wheat;
          color: red;
        "
      >
        READ ONLY
      </div>
      <h4>All</h4>
      <!-- team select -->
      <!-- <v-select
        :items="['CAO', 'MET1', 'MET2', 'Other']"
        v-model="team"
        @change="team_select"
        label="Your Team"
      ></v-select> -->

      <v-text-field
        v-mask="'##/##/####'"
        maxlength="10"
        v-model="stat_data.stat_date"
        label="Date"
      ></v-text-field>
      <v-select
        v-model="stat_data.area"
        :items="area_items"
        :rules="[(v) => !!v || 'Item is required']"
        label="AREA"
        required
        background-color="#ECEFF1"
      ></v-select>

      <h4>Standard</h4>
      <!-- <v-select
        v-model="stat_data.mission"
        :items="mission_types"
        label="MISSION"
        background-color="#ECEFF1"
        :rules="[(v) => !!v || 'Item is required']"
      >
        <template v-slot:item="slotProps">
          {{ slotProps.item }}
        </template>
      </v-select> -->

      <div>
        <v-text-field
          maxlength="120"
          v-if="stat_data.area == 'Other'"
          placeholder="Enter Other Area Name"
          v-model="stat_data.other_area"
          label="Other Area"
          solo
        ></v-text-field>
        <!-- 
        <v-text-field
          maxlength="120"
          v-if="stat_data.mission == 'Other'"
          id="other_mission"
          placeholder="Enter Other Mission Name"
          v-model="stat_data.other_mission"
          label="Other Mission"
          solo
        ></v-text-field> -->
        <!-- checkboxes HAHA HA -->

        <!-- mobile drops -->
        <v-container class="pa-0 smonly" id="mobile_drops">
          <!-- Planned Operations -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="hours_worked">Planned Operations</label>
            <select
              class="bcs_sel"
              v-model="stat_data.planned_operations"
              id="planned_operations"
            >
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- cfs_handled -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="cfs_handled">CFS Handled</label>
            <select
              class="bcs_sel"
              v-model="stat_data.cfs_handled"
              id="cfs_handled"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- felony_arrests -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="felony_arrests">Felony Arrests</label>
            <select
              class="bcs_sel"
              v-model="stat_data.felony_arrests"
              id="felony_arrests"
            >
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- gf_arrests -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl">Gross Misdo Arrests</label>
            <select
              class="bcs_sel"
              v-model="stat_data.gf_arrests"
              id="gf_arrests"
            >
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- misdo_arrests -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl">Misdo Arrests</label>
            <select
              class="bcs_sel"
              v-model="stat_data.misdo_arrests"
              id="misdo_arrests"
            >
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!--rmc_cites-->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="rmc_cites">RMC Cites</label>
            <select
              class="bcs_sel"
              v-model="stat_data.rmc_cites"
              id="rmc_cites"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- traffic_stops -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="traffic_stops">Traffic Stops</label>
            <select
              class="bcs_sel"
              v-model="stat_data.traffic_stops"
              id="traffic_stops"
            >
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- traffic_citations -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="traffic_citations">Traffic Cites</label>
            <select
              class="bcs_sel"
              v-model="stat_data.traffic_citations"
              id="traffic_citations"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- warnings -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="warnings">Warnings</label>
            <select class="bcs_sel" v-model="stat_data.warnings" id="warnings">
              <option v-for="(aint, index) in d60" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- area_check -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="area_check">Area Check</label>
            <select
              class="bcs_sel"
              v-model="stat_data.area_check"
              id="area_check"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- bus_contacts -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="bus_contacts">Business Contacts</label>
            <select
              class="bcs_sel"
              v-model="stat_data.bus_contacts"
              id="bus_contacts"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- business_check -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="business_check">Business Check</label>
            <select
              class="bcs_sel"
              v-model="stat_data.business_check"
              id="business_check"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- citizen_contacts -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="citizen_contacts"
              >Citizen Contacts</label
            >
            <select
              class="bcs_sel"
              v-model="stat_data.citizen_contacts"
              id="citizen_contacts"
            >
              <option v-for="(aint, index) in d60" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- unsheltered_contacts -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="unsheltered_contacts"
              >Unsheltered Contacts</label
            >
            <select
              class="bcs_sel"
              v-model="stat_data.unsheltered_contacts"
              id="unsheltered_contacts"
            >
              <option v-for="(aint, index) in d60" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- deeds_outreachs -->
          <div class="d-flex justify-start mt-4">
            <label class="bcs_lbl" for="deeds_outreach"
              >Outreach Offered
            </label>
            <select
              class="bcs_sel"
              v-model="stat_data.deeds_outreach"
              id="deeds_outreach"
            >
              <option v-for="(aint, index) in d60" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!--deeds_outreach_accepted-->
          <div class="d-flex justify-start mt-4">
            <label class="bcs_lbl" for="deeds_outreach_accepted"
              >Outreach Accepted</label
            >
            <select
              class="bcs_sel"
              v-model="stat_data.deeds_outreach_accepted"
              id="deeds_outreach_accepted"
            >
              <option v-for="(aint, index) in d60" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- Controlled substances_seized -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="substances_seized"
              >Controlled Substances Seized (Grams)</label
            >
            <v-text-field
              class="controlled"
              single-line
              style="width: 80%"
              id="substances_seized"
              type="number"
              v-model="stat_data.substances_seized"
            ></v-text-field>
          </div>

          <!-- firearms_seized -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="firearms_seized">Firearms Seized</label>
            <select
              class="bcs_sel"
              v-model="stat_data.firearms_seized"
              id="firearms_seized"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- CPTEDs-->
          <div class="d-flex justify-start">
            <label class="bcs_lbl" for="firearms_seized">CPTED</label>
            <select class="bcs_sel" v-model="stat_data.cpted" id="cpted">
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- Inspections-->
          <div class="d-flex justify-start">
            <label class="bcs_lbl"> Inspections</label>
            <select
              class="bcs_sel"
              v-model="stat_data.motel_inspections"
              id="motel_inspections"
            >
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- Vehicle Posted -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl">Vehicle Posted</label>
            <select
              class="bcs_sel"
              v-model="stat_data.vehicle_posted"
              id="d20arrest"
            >
              <option v-for="(aint, index) in d30" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>
          <!-- Vehicle Towed -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl">Vehicle Towed</label>
            <select
              class="bcs_sel"
              v-model="stat_data.vehicle_towed"
              id="vehicle_towed"
            >
              <option v-for="(aint, index) in d10" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <!-- service_request -->
          <div class="d-flex justify-start">
            <label class="bcs_lbl">Service Request</label>
            <select
              class="bcs_sel"
              v-model="stat_data.service_request"
              id="service_request"
            >
              <option v-for="(aint, index) in d20" :key="index" :value="aint">
                {{ aint }}
              </option>
            </select>
          </div>

          <div></div>
          <div class="mt-4">
            <label class="bcs_lbl" for="notes">Narrative</label>
            <v-textarea
              id="notes"
              class="mt-2"
              counter
              solo
              name="notes"
              v-model="stat_data.notes"
            ></v-textarea>
          </div>

          <div id="hidedeeds" v-if="false">
            <h4 class="mt-2">DEEDS</h4>
            <hr class="thick" />
            <!-- fourth street -->
            <div class="d-flex justify-start">
              <label class="bcs_lbl" for="d20frthSt"
                >Total hours in the Fourth Street Corridor</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.deeds_fourth_street"
                id="d20frthSt"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- deeds_warnings -->
            <div class="d-flex justify-start mt-4">
              <label class="bcs_lbl" for="d20warnings">Warnings&nbsp;</label>
              <select
                class="bcs_sel"
                v-model="stat_data.deeds_warnings"
                id="d20wareings"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- deeds_calls_service -->
            <div class="d-flex justify-start mt-4">
              <label class="bcs_lbl" for="d20deeds_calls_service"
                >Calls for Service&nbsp;</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.deeds_calls_service"
                id="deeds_calls_service"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!--   deeds_outreach -->
            <div class="d-flex justify-start mt-4">
              <label class="bcs_lbl" for="d20deeds_outreachs"
                >Individuals Offered Outreach/ Services
              </label>
              <select
                class="bcs_sel"
                v-model="stat_data.deeds_outreach"
                id="d20deeds_outreach"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!--deeds_outreach_accepted-->
            <div class="d-flex justify-start mt-4">
              <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
                >Individuals Accepted Outreach/ Services</label
              >
              <select
                class="bcs_sel"
                v-model="stat_data.deeds_outreach_accepted"
                id="d20ddeeds_outreach_accepted"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <div class="mt-4" v-if="false">
            <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
              >Use of Cares Campus</label
            >
            <v-textarea
              counter
              maxlength="8000"
              solo
              name="deeds_cares_campus"
              v-model="stat_data.deeds_cares_campus"
              hint="Utilizing Cares Campus or have they been 86'd"
            ></v-textarea>
          </div>
          <div class="mt-4" v-if="false">
            <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
              >Non-Use of Cares Campus</label
            >
            <v-textarea
              counter
              maxlength="8000"
              class="mt-2"
              solo
              name="non_deeds_cares_campus"
              v-model="stat_data.deeds_non_cares_campus"
              hint="What barriers exist for the individual to use the Cares Campus?"
            ></v-textarea>
          </div>
          <hr class="mt-2 mb-2" />

          <!-- save/reset buttons -->
          <v-row class="" v-if="!readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="save_stat"
              >
                Submit
              </v-btn>
              <v-btn
                v-if="edit_on == true"
                color="cmpbk"
                class="mr-4 white--text"
                @click="cancel_edit"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="edit_on == false"
                color="cmpbk"
                class="mr-4 white--text"
                @click="reset"
              >
                Reset Form
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="" v-if="readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                id="quit_view"
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="quit_view"
              >
                Quit View
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- deskstop -->
        <v-container class="pa-0 mdonly">
          <!-- row 1 -->
          <div class="mt-3 drop-row d-flex justify-center align-end">
            <!-- new rows 1 -->
            <div class="sel-int-col-25">
              <label for="d20cites">Planned Operations</label>
              <select v-model="stat_data.planned_operations" id="d20cites">
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <div class="sel-int-col-25">
              <label for="d20cites">CFS Handled</label>
              <select v-model="stat_data.cfs_handled" id="d20cites">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <div class="sel-int-col-25">
              <label for="felony_arrests">Felony Arrests</label>
              <select v-model="stat_data.felony_arrests" id="felony_arrests">
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- misdo_arrests -->
            <div class="sel-int-col-25">
              <label for="gf_arrests">Gross Misdo Arrests</label>
              <select v-model="stat_data.gf_arrests" id="gf_arrests">
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 2 -->
          <div class="drop-row d-flex justify-center align-end">
            <!-- misdo_arrests -->
            <div class="sel-int-col-25">
              <label for="misdo_arrests">Misdo Arrests</label>
              <select v-model="stat_data.misdo_arrests" id="misdo_arrests">
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- rmc_cites -->
            <div class="sel-int-col-25">
              <label for="rmc_cites">RMC Cites</label>
              <select v-model="stat_data.rmc_cites" id="rmc_cites">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- traffic_stops -->
            <div class="sel-int-col-25">
              <label for="traffic_stops">Traffic Stops</label>
              <select v-model="stat_data.traffic_stops" id="traffic_stops">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 3 -->
          <div class="drop-row d-flex justify-center align-end">
            <div class="sel-int-col-25">
              <label for="traffic_citations">Traffic Cites</label>
              <select
                v-model="stat_data.traffic_citations"
                id="traffic_citations"
              >
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- warnings -->
            <div class="sel-int-col-25">
              <label for="warnings">Warnings</label>
              <select v-model="stat_data.warnings" id="warnings">
                <option v-for="(aint, index) in d60" :key="index">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- area_check -->
            <div class="sel-int-col-25">
              <label for="area_check">Area Check</label>
              <select v-model="stat_data.area_check" id="area_check">
                <option v-for="(aint, index) in d60" :key="index">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- business_check -->
            <div class="sel-int-col-25">
              <label for="business_check">Business Check</label>
              <select v-model="stat_data.business_check" id="business_check">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 4 -->
          <div class="drop-row d-flex justify-center align-end">
            <!-- Business Contacts -->
            <div class="sel-int-col-25">
              <label for="bus_contacts">Business <br />Contacts</label>
              <select v-model="stat_data.bus_contacts" id="bus_contacts">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- citizen_contacts -->
            <div class="sel-int-col-25">
              <label for="citizen_contacts">Citizen Contacts&nbsp;</label>
              <select
                v-model="stat_data.citizen_contacts"
                id="citizen_contacts"
              >
                <option v-for="(aint, index) in d60" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- unsheltered_contacts -->
            <div class="sel-int-col-25">
              <label for="citizen_contacts">Unsheltered Contacts&nbsp;</label>
              <select v-model="stat_data.contacts" id="unsheltered_contacts">
                <option v-for="(aint, index) in d60" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!--   deeds_outreach -->
            <div class="sel-int-col-25">
              <label for="deeds_outreach">Offered Outreach </label>
              <select v-model="stat_data.deeds_outreach" id="deeds_outreach">
                <option v-for="(aint, index) in d60" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 5 -->
          <div class="drop-row d-flex justify-center align-end mt-4">
            <!--deeds_outreach_accepted-->
            <div class="sel-int-col-25">
              <label for="deeds_outreach_accepted">Accepted Outreach</label>
              <select
                v-model="stat_data.deeds_outreach_accepted"
                id="deeds_outreach_accepted"
              >
                <option v-for="(aint, index) in d60" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <div class="sel-int-col-25">
              <label for="substances_seized"
                >Controlled Substances Seized (Grams)</label
              >
              <v-text-field
                class="controlled"
                style="height: 45px; width: 80%"
                id="substances_seized"
                type="number"
                v-model="stat_data.substances_seized"
              ></v-text-field>
            </div>

            <div class="sel-int-col-25">
              <label for="firearms_seized">Firearms Seized</label>
              <select v-model="stat_data.firearms_seized" id="firearms_seized">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- CPTEDs -->
            <div class="sel-int-col-25">
              <label>CPTEDs</label>
              <select v-model="stat_data.cpted" id="cpted">
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>
          <!-- row 6 -->
          <div class="drop-row d-flex justify-center align-end mt-4">
            <div class="sel-int-col-25">
              <label>Inspections</label>
              <select
                v-model="stat_data.motel_inspections"
                id="motel_inspections"
              >
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- Vehicle Posted -->
            <div class="sel-int-col-25">
              <label>Vehicle Posted</label>
              <select v-model="stat_data.vehicle_posted" id="d20arrest">
                <option v-for="(aint, index) in d30" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
            <!-- Vehicle Towed -->
            <div class="sel-int-col-25">
              <label>Vehicle Towed</label>
              <select v-model="stat_data.vehicle_towed" id="d20dui">
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>

            <!-- Help Ticket -->
            <div class="sel-int-col-25">
              <label>Help Ticket</label>
              <select v-model="stat_data.help_tickets" id="d20accident">
                <option v-for="(aint, index) in d10" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>

          <!-- row 7 -->
          <div class="drop-row d-flex justify-center align-end mt-4">
            <div class="sel-int-col-25">
              <label>Service Request</label>
              <select v-model="stat_data.service_request" id="service_request">
                <option v-for="(aint, index) in d20" :key="index" :value="aint">
                  {{ aint }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="drop-row d-flex justify-center align-end mt-2"
            style="height: auto"
          >
            <div class="mt-4" style="width: 100%">
              <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
                >Narrative</label
              >
              <v-textarea
                class="mt-2"
                counter
                solo
                name="notes"
                v-model="stat_data.notes"
              ></v-textarea>
            </div>
          </div>
          <div id="hidedeeds" v-if="false">
            <!-- DEEDS -->
            <h4 class="pa-0 ma-0 mt-4">DEEDS</h4>
            <hr class="thick" />
            <div
              class="drop-row d-flex justify-center align-end"
              style="height: auto"
            >
              <div class="sel-int-col-25">
                <label class="bcs_lbl" for="d20frthSt"
                  >Hours Fourth Street</label
                >
                <select
                  class="bcs_sel"
                  v-model="stat_data.deeds_fourth_street"
                  id="d20frthSt"
                >
                  <option
                    v-for="(aint, index) in d20"
                    :key="index"
                    :value="aint"
                  >
                    {{ aint }}
                  </option>
                </select>
              </div>
              <div class="sel-int-col-25">
                <label class="bcs_lbl" for="d20warnings">Warnings&nbsp;</label>
                <select
                  class="bcs_sel"
                  v-model="stat_data.deeds_warnings"
                  id="d20wareings"
                >
                  <option
                    v-for="(aint, index) in d20"
                    :key="index"
                    :value="aint"
                  >
                    {{ aint }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="mt-4" v-if="false">
            <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
              >Use of Cares Campus</label
            >
            <v-textarea
              solo
              counter
              name="deeds_cares_campus"
              v-model="stat_data.deeds_cares_campus"
              hint="Utilizing Cares Campus or have they been 86'd?"
            ></v-textarea>
          </div>
          <div class="mt-4" v-if="false">
            <label class="bcs_lbl" for="d20ddeeds_outreach_accepted"
              >Non-Use of Cares Campus</label
            >
            <v-textarea
              class="mt-2"
              counter
              solo
              name="deeds_cares_campus"
              v-model="stat_data.deeds_non_cares_campus"
              hint="What barriers exist for the individual to use the Cares Campus?"
            ></v-textarea>
          </div>
          <hr class="mt-4 mb-4" />

          <!-- save/reset buttons -->
          <v-row class="" v-if="!readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="save_stat"
              >
                Submit
              </v-btn>
              <v-btn
                v-if="edit_on == true"
                color="cmpbk"
                class="mr-4 white--text"
                @click="cancel_edit"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="edit_on == false"
                color="cmpbk"
                class="mr-4 white--text"
                @click="reset"
              >
                Reset Form
              </v-btn>
            </v-col>
          </v-row>
          <!-- save/reset buttons -->
          <v-row class="" v-if="readonly">
            <v-col cols="12" class="d-flex justify-space-between">
              <v-btn
                id="quit_view"
                color="cmpbk"
                class="mr-4 white--text"
                @click.prevent="quit_view"
              >
                Quit View
              </v-btn>
            </v-col>
            <!-- <v-col cols="6">
          <v-btn color="cmpbk" class="mr-4 white--text" @click="reset">
            Reset Form
          </v-btn>
        </v-col> -->
          </v-row>
        </v-container>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
@media (min-width: 0px) {
  .thick {
    border: 1px solid rgb(3, 3, 82);
    margin-bottom: 3px;
  }
  .controlled:deep #substances_seized {
    text-align: right;
  }
  .smonly div.d-flex {
    margin-top: 10px;
  }
  .bcs_sel {
    width: 50%;
    // border: 1px solid black;
    background-color: whitesmoke;
    padding: 3px;
    margin-top: 3px;
  }
  .bcs_lbl {
    width: 50% !important;
    padding: 3px;
    margin-top: 6px;
  }
  .mdonly {
    display: none;
  }

  .drop-row {
    height: 95px;
  }
  .sel-int-col-25 {
    width: 25%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-33 {
    width: 33%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-50 {
    width: 50%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }
  .sel-int-col-100 select {
    width: 78%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
  // .sel-int-col-25 label {
  //   position: relative;
  //   top: 25px;
  // }
  .sel-int-col-25 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-50 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-33 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .sel-int-col-33 input {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
  .stop-select {
    width: 95% !important;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    margin-left: 0 !important;
  }

  select {
    -webkit-appearance: listbox !important;
    appearance: listbox !important;
  }
  .v-input--selection-controls.v-input {
    height: 40px;
  }
}
/* 768 media q */
@media (min-width: 768px) {
  .mdonly {
    display: block;
  }
  .smonly {
    display: none;
  }
  .sel-int-col-100 select {
    width: 100%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;

    // position: relative;
    // top: 10px;
  }
  .stop-select {
    width: 95% !important;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    margin-left: 0 !important;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}
/* 1025 media q */
@media (min-width: 1025px) {
}
/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "add_edit",
  mixins: [bus_common],
  components: {},
  props: [
    "addedit_update_now",
    "incoming_edit",
    "source",
    "scrollpos",
    "edit_on",
    "lst_grants",
    "team",
    "readonly",
  ],
  //source will be 'srch' or 'rcnt'
  //scroll postion the name of the scroll postion
  data: () => ({
    show_addedit: true,
    address: "",
    loc: {},
    map_dialog_visible: false,
    stat_data: {
      rpd_stat_Id: 0,
      misdo_cites: 0,
      motel_inspections: 0,
      cpted: 0,
      firearms_seized: 0,
      substances_seized: 0,
      community_court: 0,
      planned_operations: 0,
      reports_taken_generated: 0,
      cfs_handled: 0,
      field_interviews: 0,
      traffic_citations: 0,
      other_citations: 0,
      traffic_stops: 0,
      bus_contacts: 0,
      other_contacts: 0,
      team: "",
      stat_date: "",
      area: "",
      other_area: "",
      mission: "",
      other_mission: "",
      cites: 0,
      misdo_arrests: 0,
      gf_arrests: 0,
      vehicle_posted: 0,
      vehicle_towed: 0,
      help_tickets: 0,
      contacts: 0,
      deeds_total_fourth_street: 0,
      deeds_citizen_contacts: 0,
      deeds_arrests: 0,
      deeds_citations: 0,
      deeds_warnings: 0,
      deeds_calls_service: 0,
      deeds_business_contacts: 0,
      deeds_planned_operations: 0,
      deeds_outreach: 0,
      deeds_outreach_accepted: 0,
      deeds_cares_campus: "",
      deeds_non_cares_campus: "",
      notes: "",
      downtown: 0,
      hours_worked: 0,
      felony_arrests: 0,
      rmc_cites: 0,
      warnings: 0,
      area_check: 0,
      business_check: 0,
      citizen_contacts: 0,
      unsheltered_contacts: 0,
      service_request: 0,
    },
    stat_data_new_dev: {
      rpd_stat_Id: 0,
      misdo_cites: 31,
      motel_inspections: 1,
      cpted: 2,
      firearms_seized: 3,
      substances_seized: 500,
      community_court: 4,
      planned_operations: 5,
      reports_taken_generated: 6,
      cfs_handled: 7,
      field_interviews: 8,
      traffic_citations: 9,
      other_citations: 10,
      traffic_stops: 6,
      bus_contacts: 12,
      other_contacts: 13,
      team: "CAO",
      stat_date: "2024-12-01",
      area: "DEEDS",
      other_area: "",
      mission: "City Walk",
      other_mission: "",
      cites: 14,
      misdo_arrests: 9,
      gf_arrests: 16,
      vehicle_posted: 17,
      vehicle_towed: 8,
      help_tickets: 5,
      contacts: 20,
      deeds_fourth_street: 21,
      deeds_citizen_contacts: 22,
      deeds_arrests: 23,
      deeds_citations: 24,
      deeds_warnings: 25,
      deeds_calls_service: 26,
      deeds_business_contacts: 27,
      deeds_planned_operations: 28,
      deeds_outreach: 29,
      deeds_outreach_accepted: 30,
      deeds_cares_campus: "deeds_cares_campus",
      deeds_non_cares_campus: "deeds_cares_campus",
      notes: "notes",
      downtown: 31,
      hours_worked: 8,
      felony_arrests: 9,
      rmc_cites: 11,
      warnings: 50,
      area_check: 3,
      business_check: 20,
      citizen_contacts: 49,
      unsheltered_contacts: 59,
      service_request: 19,
    },
    stat_data_new: {
      rpd_stat_Id: 0,
      misdo_cites: 0,
      motel_inspections: 0,
      cpted: 0,
      firearms_seized: 0,
      substances_seized: 0,
      community_court: 0,
      planned_operations: 0,
      reports_taken_generated: 0,
      cfs_handled: 0,
      field_interviews: 0,
      traffic_citations: 0,
      traffic_stops: 0,
      other_citations: 0,
      bus_contacts: 0,
      other_contacts: 0,
      team: "",
      stat_date: "",
      area: "",
      other_area: "",
      mission: "",
      other_mission: "",
      cites: 0,
      misdo_arrests: 0,
      gf_arrests: 0,
      vehicle_posted: 0,
      vehicle_towed: 0,
      help_tickets: 0,
      contacts: 0,

      deeds_total_fourth_street: 0,
      deeds_citizen_contacts: 0,
      deeds_arrests: 0,
      deeds_citations: 0,
      deeds_warnings: 0,
      deeds_calls_service: 0,
      deeds_business_contacts: 0,
      deeds_planned_operations: 0,
      deeds_outreach: 0,
      deeds_outreach_accepted: 0,
      deeds_cares_campus: "",
      deeds_non_cares_campus: "",
      notes: "",
      downtown: 0,
      hours_worked: 0,
      felony_arrests: 0,
      rmc_cites: 0,
      warnings: 0,
      area_check: 0,
      business_check: 0,
      citizen_contacts: 0,
      unsheltered_contacts: 0,
      service_request: 0,
    },
    update_ready: false,
    valid: true,
    name: "",
    locRules: [(v) => !!v || "Location is required"],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    types: ["Traffic", "Warrant", "Dispatch", "Complaint"],
    area_items: ["Downtown Corridor", "DEEDS", "City of Reno", "Other"],
    mission_types: [
      "DID Operation (ex: 4th street saturation Op/ Shopping Cart Op/ UC op)",
      "Area Check",
      "Ambassador Assist",
      "Business Check",
      "Call for Service",
      "Camp Cleanup",
      "City Walk",
      "Service Request",
      "Warrant Sweep",
      "Motel Inspection",
      "CPTED",
      "Other",
    ],
    checkbox: false,
  }),
  watch: {
    addedit_update_now: function (val) {
      if (this.update_ready) {
        this.update_ready = true;
        this.swall_it("Entry Status", "Entry Saved", "success");
        this.stat_data = this.mno(this.stat_data_new);
        this.$nextTick(() => {
          this.stat_data.stat_date = this.format_date_us(new Date());
        });

        console.log("Stat Date: " + this.stat_data.stat_date);
      }
    },
    incoming_edit: function (stat) {
      this.stat_data = this.mno(stat);
      this.stat_data.stat_date = this.format_date_us(this.stat_data.stat_date);
      this.stat_data.area = this.stat_data.area.trim();
      this.stat_data.mission = this.stat_data.mission.trim();
      console.log("area: " + this.stat_data.area);
      console.log("mission: " + this.stat_data.mission);
      if (this.stat_data.area.indexOf("Other") > -1) {
        this.stat_data.area = "Other";
      }
      if (this.stat_data.mission.indexOf("Other") > -1) {
        this.stat_data.mission = "Other";
      }
    },
  },
  computed: {
    team_met() {
      if (this.edit_on) {
        if (this.stat_data.team == "MET1" || this.stat_data.team == "MET2") {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.team == "MET1" || this.team == "MET2") {
          return true;
        } else {
          return false;
        }
      }
    },
    d10() {
      var d10 = [];
      for (let index = 0; index < 11; index++) {
        d10.push(index);
      }
      return d10;
    },
    d20() {
      var d20 = [];
      for (let index = 0; index < 21; index++) {
        d20.push(index);
      }
      return d20;
    },
    d30() {
      var d30 = [];
      for (let index = 0; index < 31; index++) {
        d30.push(index);
      }
      return d30;
    },
    d60() {
      var d60 = [];
      for (let index = 0; index < 61; index++) {
        d60.push(index);
      }
      return d60;
    },
    grants() {
      var grants = [];
      grants.push("None");
      for (let index = 0; index < this.lst_grants.length; index++) {
        const element = this.lst_grants[index];
        grants.push(element.grant_name);
      }
      return grants;
    },
    tsep_fromId() {
      return this.$store.state.edit_tsep_fromId;
    },
  },
  methods: {
    team_select() {
      let self = this;
      console.log("team_select save");
      if (this.team != "") {
        //save user team
        let formIn = {};
        formIn.email = this.$store.state.user.email;
        formIn.token = this.$store.state.user.token;
        formIn.team = this.team;
        formIn.apiname = "save_team_user";

        let self = this;
        this.$store
          .dispatch("anyapi", formIn)
          .then((data) => {
            self.team = data;
            self.panels = 0;
          })
          .catch((msg) => {
            self.dialog = false;
            this.show_loader(false);
            this.swall_it("Error save_team_user", msg, "error", null, null);
          });
      }
    },
    quit_view() {
      //this will also set read only to false putting us in the basic state
      this.$emit("cancel_edit", this.stat_data);
    },
    save_stat() {
      var total = 0;
      if (this.stat_data.area == "") {
        this.swall_it(
          "Save Status ",
          "Please be sure you have selected an Area before submitting. ",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.team == "" || this.team == null) {
        this.swall_it(
          "Save Status ",
          "Team not found. Change you team and try again. ",
          "warning",
          null,
          null
        );
        return true;
      }
      this.stat_data.team = this.team;
      this.stat_data.stat_date = this.format_date_sql(
        new Date(this.stat_data.stat_date)
      );
      console.log(this.stat_data.stat_date);
      console.log("notes:" + this.stat_data.notes);

      this.stat_data.cites = parseInt(this.stat_data.cites);
      this.stat_data.misdo_arrests = parseInt(this.stat_data.misdo_arrests);
      this.stat_data.gf_arrests = parseInt(this.stat_data.gf_arrests);
      this.stat_data.vehicle_posted = parseInt(this.stat_data.vehicle_posted);

      this.stat_data.vehicle_towed = parseInt(this.stat_data.vehicle_towed);
      this.stat_data.help_tickets = parseInt(this.stat_data.help_tickets);
      this.stat_data.contacts = parseInt(this.stat_data.contacts);

      this.stat_data.motel_inspections = parseInt(
        this.stat_data.motel_inspections
      );
      this.stat_data.cpted = parseInt(this.stat_data.cpted);
      this.stat_data.firearms_seized = parseInt(this.stat_data.firearms_seized);
      this.stat_data.substances_seized = parseInt(
        this.stat_data.substances_seized
      );
      this.stat_data.community_court = parseInt(this.stat_data.community_court);
      this.stat_data.planned_operations = parseInt(
        this.stat_data.planned_operations
      );
      this.stat_data.reports_taken_generated = parseInt(
        this.stat_data.reports_taken_generated
      );
      this.stat_data.cfs_handled = parseInt(this.stat_data.cfs_handled);
      this.stat_data.field_interviews = parseInt(
        this.stat_data.field_interviews
      );
      this.stat_data.traffic_citations = parseInt(
        this.stat_data.traffic_citations
      );
      this.stat_data.other_citations = parseInt(this.stat_data.other_citations);
      console.log("oc " + this.stat_data.other_citations);
      this.stat_data.traffic_stops = parseInt(this.stat_data.traffic_stops);
      this.stat_data.bus_contacts = parseInt(this.stat_data.bus_contacts);
      this.stat_data.other_contacts = parseInt(this.stat_data.other_contacts);

      this.stat_data.downtown = parseInt(this.stat_data.downtown);
      console.log("hours worked: " + this.stat_data.hours_worked);
      this.stat_data.hours_worked = parseInt(this.stat_data.hours_worked);

      this.stat_data.unsheltered_contacts = parseInt(
        this.stat_data.unsheltered_contacts
      );
      this.stat_data.felony_arrests = parseInt(this.stat_data.felony_arrests);
      this.stat_data.rmc_cites = parseInt(this.stat_data.rmc_cites);
      this.stat_data.warnings = parseInt(this.stat_data.warnings);
      this.stat_data.area_check = parseInt(this.stat_data.area_check);
      this.stat_data.business_check = parseInt(this.stat_data.business_check);
      this.stat_data.citizen_contacts = parseInt(
        this.stat_data.citizen_contacts
      );

      this.update_ready = true;
      this.$emit("save_stat", this.stat_data);
    },
    cancel_edit() {
      this.$emit("cancel_edit", this.stat_data);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.init();
      this.show_loader(false);
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    init() {
      let self = this;
      console.log(this.show_addedit);
      setTimeout(() => {
        self.stat_data = self.mno(self.stat_data_new);
        this.stat_data.team = this.team;
        this.stat_data.stat_date = this.format_date_us(new Date());
      }, 500);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
